<!--
배송단계별 수량집계
 - 배송조회 페이지 상단에 사용됨.
-->
<template>
    <div class="panel">

        <div class="uk-flex uk-flex-left uk-flex-wrap uk-flex-top" v-if="hasGeneral || highlightStates.length > 0">
            <!-- 총괄관리자 관리버튼  -->
            <a class="btn btn-style manage"
               :href="this.baseUrl + '?otp=yes'"
               @if="hasGeneral"
            >
                <i class="material-icons">search</i>
                OTP 조회
            </a>

            <a class="btn btn-style manage"
               :href="this.baseUrl + '?fta=yes'"
               @if="hasGeneral"
            >
                <i class="material-icons">search</i>
                FTA 조회
            </a>

            <!-- 강조단계 -->
            <a class="btn btn-style highlight"

               v-for="(item, index) in highlightStates"
               :key="index"
               :href="makeUrl(item)"
            >
                {{ item.text }}
                <b v-if="item.count">
                    ({{ item.count }})
                </b>
            </a>
        </div>

        <!-- 일반 단계표시 -->
        <div class="uk-flex uk-flex-left uk-flex-wrap uk-flex-top">

            <a class="btn btn-style"

               v-for="(item, index) in normalStates"
               :key="index"
               :href="makeUrl(item)"
            >
                {{ item.text }}
                <b v-if="item.count">
                    ({{ item.count }})
                </b>
            </a>

        </div>

    </div>
</template>

<script>
export default {
    props: {
        /**
         * 창고작업자 권한 여부
         */
        hasGeneral: {
            type: Boolean,
            default: false
        },

        /**
         * 창고작업자 권한 여부
         */
        hasRegion: {
            type: Boolean,
            default: false
        },
        /**
         * 링크작성에 사용되는 기본 url
         *  - e.g. '/regions/2/prods'
         */
        baseUrl: {
            type: String,
            required: true,
        },

        /**
         * 단계별 수량정보 배열
         * [
         *      {state: 1, text: '접수완료', count: 12},
         *      {state: 32, text: '벤더배송중', count: 20},
         *      .
         *      .
         *      .
         * ]
         */
        items: {
            type: Array,
            required: true,
        },
    },
    data: function () {
        return {
            // 창고 강조단계
            warehouseHighlightStates: [
                32, // 벤더배송중
                41, // 트래킹스캔
                60, // 발송요청
                72, // 출고완료
                74, // 출고요청
                81, // 항공운송중
                83, // 통관중
            ],

            // 하이라이트 단계 배열
            highlightStates: [],

            // 일반 단계 배열
            normalStates: [],
        };
    },
    mounted() {
        const [highightStates, normalStates] = _.partition(this.items, (item) => {
            return this.hasRegion && this.warehouseHighlightStates.includes(item.state);
        });
        this.highlightStates = highightStates;
        this.normalStates = normalStates;
    },
    computed: {
    },
    methods: {
        /**
         * 링크
         * @param {object} item
         * @returns {string}
         */
        makeUrl(item) {
            let url = this.baseUrl + '?';
            if (item.state) {
                url += '&state=' + item.state;
            }

            if (item.state === 41) {
                // 트래킹스캔단계는 입고일정렬 추가
                url += '&order_by=shipin_at_asc';

            } else if (item.state === 83) {
                // 통관중단계는 출고일 정렬 추가
                url += '&order_by=shipout_at_asc';

            } else if (item.state === 32) {
                // 벤더배송중 단계는 현지배송일 정렬 추가
                url += '&order_by=vd_deli_at_asc';
            }


            return url;
        },
    },
}
</script>

<style lang="scss" scoped>
.panel {
    background-color: #fff;
    //border: 1px solid #ddd;
    padding: 10px;

    .btn {
        margin-right: 0.5rem;
        margin-bottom: 0.25rem;
    }

    .btn-style {

        border: 0;
        outline: 0;
        cursor: pointer;
        color: #666;
        background-color: rgb(255, 255, 255);
        box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
        border-radius: 4px;
        padding: 4px 8px;
        display: inline-block;
        transition: background-color .24s,box-shadow .24s;

        &:hover {
            box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 12%) 0px 1px 1px 0px, rgb(60 66 87 / 16%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 3px 9px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
        }



        &.highlight {
            background-color: #FFFF66;
            color: #000;
            box-shadow: rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgba(0, 0, 0, 0.25) 0px 1px 1px 0px, rgba(0, 0, 0, 0.25) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(0 0 0 / 0%) 0px 0px 0px 0px, rgb(60 66 87 / 8%) 0px 2px 5px 0px;
        }

        &.manage {
            background-color: #344766;
            color: #c3cee0;
            border: 1px solid #344766;
            box-shadow: initial;
        }
    }
}
</style>